export default __webpack_public_path__ + "static/media/pos-dashboard.80d3a5bd.jpg";